import styled from 'styled-components';
import { Button } from '@mui/material';

import colors from '../../styles/colors';
import OnCallActions from '../OnCallActions';

const Container = styled.div`
  margin: 0 5px 15px 0px;
`;

const ContractInfoLine = styled.div`
  display: flex;
  flex-direction: row;
`;

const ContractInfoKey = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.shades.secondary3};
`;

const ContractInfoValue = styled.span`
  display: inline-block;
  margin-left: 5px;
  font-size: 14px;
  color: ${colors.base.beta};
`;

const StyledOnCallActions = styled(OnCallActions)`
  padding-top: 15px;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 10px;
`;

const HeaderActionButton = styled(Button)`
  background: ${colors.shades.gamma2};
  color: ${colors.base.alpha};
  text-transform: none;
  font-size: 12px;
  min-width: 120px;
  &:hover {
    background: ${colors.base.beta};
  }
`;

export {
  Container,
  ContractInfoLine,
  ContractInfoKey,
  ContractInfoValue,
  StyledOnCallActions,
  HeaderActions,
  HeaderActionButton,
};
